export default {"src":"/_next/static/media/arrow.faf979cd.svg","height":24,"width":24};